import { AppAndroidProvider, AppBrowserProvider, AppIosProvider } from "@kiddocare-platform/portal-common/contexts";
import { useLogger } from "@kiddocare-platform/portal-common/helpers";
import { KiddocareProvider, Prompt, Toaster } from "@kiddocare-platform/portal-common/ui";
import React, { useMemo } from "react";
import { ParentContextProvider } from "./contexts/parent.context";
import { UserBarContextProvider } from "./contexts/user-bar.context";
import { PagesRoutes } from "./pages/pages.routes";

export const App: React.FC = () => {
  const log = useLogger(App.name);

  const AppProvider = useMemo(() => {
    const iosKiddocareBridge: any = (window as any).iosKiddocareBridge;
    const androidKiddocareBridge: any = (window as any).androidKiddocareBridge;

    let AppProvider = undefined;
    if (iosKiddocareBridge) {
      log.info("Detected iosKiddocareBridge, instance AppIosProvicer");
      AppProvider = AppIosProvider;
    }
    else if (androidKiddocareBridge) {
      log.info("Detected androidKiddocareBridge, instance AppAndroidProvider");
      AppProvider = AppAndroidProvider;
    }
    else {
      log.info("instance AppBrowserProvider");
      AppProvider = AppBrowserProvider;
    }
    return AppProvider;
  }, []);

  return (
    <AppProvider>
      <ParentContextProvider>
        <KiddocareProvider>
          <UserBarContextProvider>
            <PagesRoutes />
          </UserBarContextProvider>
          <Toaster />
          <Prompt />
        </KiddocareProvider>
      </ParentContextProvider>
    </AppProvider>
  );
}